"use client";

import { c as _c } from "react/compiler-runtime";
import { RiCloseLine, RiContractRightLine, RiExpandLeftLine } from "react-icons/ri";
import { Button } from "@/components/ui";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { RIGHT_SIDEBAR_DEFAULT_WIDTH, RIGHT_SIDEBAR_MAX_WIDTH, useRightSidebarStore } from "@/stores/right-sidebar-store";
export interface SidebarHeaderTab {
  id: string;
  label: string;
  /** Omit for a tab that can't be closed on its own. */
  onClose?: () => void;
}

/** Shared chrome for every sidebar surface, including a single panel. */
export function SidebarHeader(t0) {
  const $ = _c(21);
  const {
    tabs
  } = t0;
  const {
    width,
    setWidth,
    closeAll
  } = useRightSidebarStore();
  const isExpanded = width > RIGHT_SIDEBAR_DEFAULT_WIDTH;
  let t1;
  if ($[0] !== tabs) {
    t1 = <div className="flex h-full min-w-0 flex-1 items-center overflow-x-auto">{tabs.length === 1 ? <div className="w-max text-body-strong text-foreground">{tabs[0].label}</div> : <TabsList variant="line" aria-label="Sidebar panels" className="h-full w-max min-w-full gap-5 border-b-0">{tabs.map(_temp)}</TabsList>}</div>;
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isExpanded || $[3] !== setWidth) {
    t2 = () => setWidth(isExpanded ? RIGHT_SIDEBAR_DEFAULT_WIDTH : RIGHT_SIDEBAR_MAX_WIDTH);
    $[2] = isExpanded;
    $[3] = setWidth;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isExpanded ? "Make narrower" : "Make wider";
  const t4 = isExpanded ? "Make narrower" : "Make wider";
  let t5;
  if ($[5] !== isExpanded) {
    t5 = isExpanded ? <RiContractRightLine className="size-4" /> : <RiExpandLeftLine className="size-4" />;
    $[5] = isExpanded;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <Button variant="ghost" size="icon" onClick={t2} aria-label={t3} tooltip={t4} className="hidden text-foreground-secondary md:inline-flex" icon={t5} />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <RiCloseLine className="size-3.5" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== closeAll) {
    t8 = <Button variant="ghost" size="icon" onClick={closeAll} aria-label="Close sidebar" tooltip="Close sidebar" className="text-foreground-secondary" icon={t7} />;
    $[13] = closeAll;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="flex shrink-0 items-center gap-0.5">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t1 || $[19] !== t9) {
    t10 = <div className="flex h-10 shrink-0 items-center gap-2 border-b border-border pl-4 pr-2">{t1}{t9}</div>;
    $[18] = t1;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp(tab) {
  return <div key={tab.id} className="group relative flex h-full shrink-0 items-center"><TabsTrigger value={tab.id} className="peer mb-0 inline-flex h-full flex-none items-center px-0 py-0">{tab.label}</TabsTrigger>{tab.onClose && <Button variant="ghost" size="icon" onClick={tab.onClose} aria-label={`Close ${tab.label} tab`} tooltip={`Close ${tab.label} tab`} className="ml-1 size-5 shrink-0 text-muted-foreground peer-data-[state=active]:text-foreground-secondary hover:text-foreground focus-visible:text-foreground" icon={<RiCloseLine className="size-3" />} />}</div>;
}